export const data = [
    {
        title: "Computer Science",
        school: "University of California, San Diego",
        degree: "Bachelor's of Science",
        link: "https://cse.ucsd.edu/",
        completed: true,
        date: "September 2023"
    },
    {
        title: "Cognitive Science: Design & Interaction",
        school: "University of California, San Diego",
        degree: "Bachelor's of Science",
        link: "https://cogsci.ucsd.edu/undergraduates/major/design-interaction.html",
        completed: true,
        date: "September 2023"
    },
]